import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setListDisplay } from "../action/list.action";
import { setStableState } from "../action/stable.action";
import { Search, X, Star, LayoutGrid, List, SlidersHorizontal } from "lucide-react";

const TableFilters = ({ searchTerm, setSearchTerm, viewMode, setViewMode }) => {
  const [showStable, setShowStable] = useState(true);
  const [showFavList, setShowFavList] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setStableState(showStable));
    dispatch(setListDisplay(showFavList));
  }, [showStable, showFavList, dispatch]);

  return (
    <div className="table-filters">
      <div className="table-filters-container">
        {/* Search Bar */}
        <div className="search-bar">
          <Search size={16} className="search-icon" />
          <input
            type="text"
            placeholder="Search crypto (name, symbol)..."
            value={searchTerm || ""}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <button className="clear-search" onClick={() => setSearchTerm("")}>
              <X size={14} />
            </button>
          )}
        </div>

        {/* Filter Pills & Options */}
        <div className="filter-options">
          <button
            className={`filter-pill ${showStable ? "active" : ""}`}
            onClick={() => setShowStable(!showStable)}
          >
            <SlidersHorizontal size={14} />
            <span>{showStable ? "With Stablecoins" : "Without Stablecoins"}</span>
          </button>

          <button
            className={`filter-pill ${!showFavList ? "active" : ""}`}
            onClick={() => setShowFavList(false)}
          >
            <span>All Cryptos</span>
          </button>

          <button
            className={`filter-pill fav-pill ${showFavList ? "active" : ""}`}
            onClick={() => setShowFavList(true)}
          >
            <Star size={14} fill={showFavList ? "#f59e0b" : "none"} color={showFavList ? "#f59e0b" : "currentColor"} />
            <span>Watchlist</span>
          </button>

          {/* View Mode Switcher */}
          <div className="view-mode-toggle">
            <button
              className={`view-btn ${viewMode === "table" ? "active" : ""}`}
              onClick={() => setViewMode("table")}
              title="Table View"
            >
              <List size={16} />
            </button>
            <button
              className={`view-btn ${viewMode === "cards" ? "active" : ""}`}
              onClick={() => setViewMode("cards")}
              title="Grid View"
            >
              <LayoutGrid size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableFilters;
